export class Company {
  constructor({
    companyID = 0,
    companyName = '',
    tradingName = '',
    entityType = '',
    directorSurname = '',
    abn = '',
    acn = '',
    driversLicenseNumber = '',
    dateOfBirth = new Date(1970, 1, 1),
    directorGivenName = '',
    otherOrganisation = false,
    guaranteeAttached = false,
    dobConsumer = new Date(),
    isdirectorSurnameRequired = false,
    isdateOfBirthRequired = false,
    industry = 'Q',
    subIndustry = 'QA',
    abn_status_from_date = new Date(),
    isUpdatedTradingName = false,
  } = {}) {
    this.companyID = companyID;
    this.companyName = companyName;
    this.tradingName = tradingName;
    this.entityType = entityType;
    this.directorSurname = directorSurname;
    this.abn = abn;
    this.acn = acn;
    this.driversLicenseNumber = driversLicenseNumber;
    this.dateOfBirth = dateOfBirth;
    this.directorGivenName = directorGivenName;
    this.otherOrganisation = otherOrganisation;
    this.guaranteeAttached = guaranteeAttached;
    this.dobConsumer = dobConsumer;
    this.isdirectorSurnameRequired = isdirectorSurnameRequired;
    this.isdateOfBirthRequired = isdateOfBirthRequired;
    this.industry = industry;
    this.subIndustry = subIndustry;
    this.abn_status_from_date = abn_status_from_date;
    this.isUpdatedTradingName = isUpdatedTradingName;
  }
}

export function createCompany(data) {
  return Object.freeze(new Company(data));
}
